<template>
  <div>
    <canvas ref="canvas" height="120px"></canvas>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

export default {
  props: {
    notes_chart: {},
    annee_academique: "",
  },
  extends: Bar,
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: this.notes_chart.labels,
      datasets: [
        {
          label: "Notes honoraires valide " + this.annee_academique,
          backgroundColor: "#d0d700",
          data: this.notes_chart.values,
        },
      ],
    },{
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 8,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontSize: 10,
              },
            },
          ],
        },
      });
  },
};
</script>
